export default "query meetings {\n    meetings {\n        id\n        format\n        code\n        name\n    }\n}";